/* BAREBORN theme JS */
(function () {
  'use strict';

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* Mobile menu */
  var burger = document.querySelector('.burger');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    });
  }

  /* Horizontal gallery: progress bar + drag */
  document.querySelectorAll('[data-hscroll]').forEach(function (hs) {
    var bar = hs.parentElement.querySelector('.h-progress i');
    function upBar() {
      if (!bar) return;
      var max = hs.scrollWidth - hs.clientWidth;
      bar.style.width = (max > 0 ? (20 + (hs.scrollLeft / max) * 80) : 100) + '%';
    }
    hs.addEventListener('scroll', upBar); upBar();
    var drag = false, sx = 0, sl = 0;
    hs.addEventListener('mousedown', function (e) { drag = true; sx = e.pageX; sl = hs.scrollLeft; hs.style.cursor = 'grabbing'; });
    window.addEventListener('mouseup', function () { drag = false; hs.style.cursor = 'grab'; });
    window.addEventListener('mousemove', function (e) { if (!drag) return; hs.scrollLeft = sl - (e.pageX - sx); });
  });

  /* Routine calculator */
  document.querySelectorAll('[data-calculator]').forEach(function (calc) {
    var base = parseFloat(calc.dataset.basePrice || '65');
    var cycles = parseFloat(calc.dataset.cyclesPerYear || '6');
    function recalc() {
      var t = 0;
      calc.querySelectorAll('.calc-item.on').forEach(function (i) { t += parseFloat(i.dataset.price || '0'); });
      var save = Math.max(0, t - base);
      var rt = calc.querySelector('[data-routine-total]');
      var st = calc.querySelector('[data-save-total]');
      var sy = calc.querySelector('[data-save-year]');
      if (rt) rt.textContent = '$' + t.toFixed(0);
      if (st) st.textContent = '$' + save.toFixed(0);
      if (sy) sy.textContent = '~$' + (save * cycles).toLocaleString();
    }
    calc.querySelectorAll('.calc-item').forEach(function (i) {
      i.addEventListener('click', function () { i.classList.toggle('on'); recalc(); });
    });
    recalc();
  });

  /* Sticky add-to-cart (PDP) */
  var buy = document.querySelector('[data-buy-area]');
  var sticky = document.getElementById('stickyCta');
  if (buy && sticky) {
    document.body.classList.add('has-sticky-cta');
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('show', window.scrollY > buy.offsetTop + buy.offsetHeight);
    });
  }

  /* PDP gallery thumbs */
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.dataset.full;
      if (btn.dataset.alt) mainImg.alt = btn.dataset.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* Offer picker -> selling plan + price sync */
  var form = document.querySelector('form[data-product-form]');
  if (form) {
    var planInput = form.querySelector('[name="selling_plan"]');
    document.querySelectorAll('.offer').forEach(function (o) {
      o.addEventListener('click', function () {
        document.querySelectorAll('.offer').forEach(function (x) { x.classList.remove('selected'); });
        o.classList.add('selected');
        if (planInput) planInput.value = o.dataset.sellingPlan || '';
        var atc = form.querySelector('[data-atc-price]');
        if (atc && o.dataset.priceLabel) atc.textContent = o.dataset.priceLabel;
      });
    });
  }
})();
